module.exports = "/images/Estonia.png?96085218ef2dc23ad1b7ed387c89688a";